import React from "react";
import "./LostJewelGamePage.css";

function LostJewelGamePage({ user }) {
    const playerName = [user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.username || "your member account";

    return (
        <main className="lost-jewel-page">
            <div className="lost-jewel-preview-banner">
                <div>
                    <strong>Game in development</strong>
                    <span>Private Connaught preview. Progress and polish may change between meetings.</span>
                </div>
                <em>Saving as {playerName}</em>
            </div>
            <iframe
                className="lost-jewel-frame"
                src="/lost-jewel-game/?build=20260927-1"
                title="The Lost Jewel game preview"
                allow="autoplay"
            />
        </main>
    );
}

export default LostJewelGamePage;
